import React, { useEffect } from 'react';

const TestsSummary = ({ 
  testsRepaso, 
  testsGenerales, 
  filteredTests, 
  categoriaActiva 
}) => {
  // Contador de tests por tema para tests de repaso
  const testsPorTema = {};
  testsRepaso.forEach(test => {
    if (test.tema) {
      testsPorTema[test.tema] = (testsPorTema[test.tema] || 0) + 1;
    }
  });
  
  // Contador de tests por vuelta
  const testsPorVuelta = {};
  [...testsRepaso, ...testsGenerales].forEach(test => {
    if (test.vuelta) {
      testsPorVuelta[test.vuelta] = testsPorVuelta[test.vuelta] || { repaso: 0, general: 0 };
      if (test.tipo === 'repaso') {
        testsPorVuelta[test.vuelta].repaso++;
      } else {
        testsPorVuelta[test.vuelta].general++;
      }
    }
  });
  
  // Log de estadísticas para verificación
  useEffect(() => {
    console.log('=== ESTADÍSTICAS DE TESTS ===');
    console.log('Tests por categoría:');
    console.log(`- Total: ${filteredTests.length}`);
    console.log(`- Repaso: ${testsRepaso.length}`);
    console.log(`- Generales: ${testsGenerales.length}`);
    
    console.log('\nTests de repaso por tema:');
    Object.entries(testsPorTema).forEach(([tema, cantidad]) => {
      console.log(`- Tema ${tema}: ${cantidad} tests`);
    });
    
    console.log('\nTests por vuelta de repaso:');
    Object.entries(testsPorVuelta)
      .sort((a, b) => parseInt(a[0]) - parseInt(b[0]))
      .forEach(([vuelta, datos]) => {
        console.log(`- Vuelta ${vuelta}: ${datos.repaso + datos.general} tests (${datos.repaso} repaso, ${datos.general} generales)`);
      });
    
    console.log('=== FIN ESTADÍSTICAS DE TESTS ===\n');
  }, [testsRepaso, testsGenerales, filteredTests, categoriaActiva, testsPorTema, testsPorVuelta]);
  
  return (
    <div className="tests-summary">
      <div className="summary-title">
        <i className="fas fa-chart-pie"></i> Resumen de tests
      </div>
      
      <div className="summary-stats">
        <div className="stat-box">
          <div className="stat-value">{filteredTests.length}</div>
          <div className="stat-label">Total tests</div>
        </div>
        <div className="stat-box repaso">
          <div className="stat-value">{testsRepaso.length}</div>
          <div className="stat-label">Tests de repaso</div>
        </div>
        <div className="stat-box general">
          <div className="stat-value">{testsGenerales.length}</div>
          <div className="stat-label">Tests generales</div>
        </div>
      </div>
      
      {categoriaActiva === 'repaso' && (
        <div className="summary-detail">
          <div className="detail-title">Tests por tema</div>
          <div className="detail-items">
            {Object.entries(testsPorTema).map(([tema, cantidad]) => (
              <div key={tema} className="detail-item">
                <span className="detail-label">Tema {tema}</span>
                <span className="detail-value">{cantidad}</span>
              </div>
            ))}
          </div>
        </div>
      )}
      
      {categoriaActiva === 'todos' && (
        <div className="summary-detail">
          <div className="detail-title">Tests por vuelta de repaso</div>
          <div className="detail-items">
            {Object.entries(testsPorVuelta)
              .sort((a, b) => parseInt(a[0]) - parseInt(b[0]))
              .map(([vuelta, datos]) => (
                <div key={vuelta} className="detail-item">
                  <span className="detail-label">Vuelta {vuelta}</span>
                  <span className="detail-value">
                    {datos.repaso + datos.general} 
                    <span className="value-breakdown">
                      ({datos.repaso} R / {datos.general} G)
                    </span>
                  </span>
                </div>
              ))
            }
          </div>
        </div>
      )}
    </div>
  );
};

export default TestsSummary;